import React from 'react';

import { Typography } from '@material-ui/core';
import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, Step } from '../SteppedForm';

import './index.css';

const StepOperatorReferral = (props) => {
  return (
    <Step
      id="operatorreferral"
      nonext
      title="Operator Referral"
      skip={(formdata) => formdata.onboardingFor === 'vehicle'}>
      <Typography variant="body1" class="formQuestion">
        Were you referred by a 13cabs or Silver Service Operator Or Driver?
      </Typography>
      <ButtonField
        id="has_referred_by_operator_or_driver"
        value={true}
        label="Yes"
        className="TopIconButton"
        startIcon={<CheckOutlinedIcon />}
      />
      <ButtonField
        id="has_referred_by_operator_or_driver"
        value={false}
        label="No"
        className="TopIconButton"
        startIcon={<ClearOutlinedIcon />}
      />
    </Step>
  );
};

export default StepOperatorReferral;
